import { Job, JobDTO } from "./Job";

export interface DeploymentDTO {
  deploymentNumber: number;
  job: JobDTO;
}

export class Deployment {
  private readonly _deploymentNumber: number;
  private readonly _job: Job;

  static create(deployment: DeploymentDTO): Deployment {
    return new Deployment(deployment);
  }

  constructor(deployment: DeploymentDTO) {
    this._deploymentNumber = deployment.deploymentNumber;
    this._job = Job.create(deployment.job);
  }

  public get deploymentNumber() {
    return this._deploymentNumber;
  }

  public get job() {
    return this._job;
  }
}
